<script setup lang="ts">
import type { CmsElementPluebelCmsElementsContactWithIcons } from "~/composables/useCustom";
const props = defineProps<{
  content: CmsElementPluebelCmsElementsContactWithIcons;
}>();
const { text, icons, headline, fliesstext } = props.content.config;
</script>

<template>
  <section class="faq-section pb-20 md:pb-24 xl:pb-36">
    <div class="container">
      <div class="max-w-[1110px] w-full m-auto relative">
        <div
          class="any-ques-wrap flex flex-wrap pt-12 md:pt-14 lg:pt-20 gap-y-8"
        >
          <div
            class="any-ques-left flex justify-center md:justify-start gap-6 lg:gap-8 text-center w-[340px] lg:w-[420px]"
          >
            <div v-for="icon in icons.value">
              <NuxtLink :to="icon.link?.url" class="ques-icon">
                <NuxtImg
                  :src="icon.icon?.url"
                  loading="lazy"
                  format="webp"
                  :alt="icon?.icon?.alt || icon?.icon?.fileName"
                  :width="icon.icon?.metaData?.width || '384'"
                  :height="icon.icon?.metaData?.height || '475'"
                />
              </NuxtLink>
              <p>{{ icon.icon_text }}</p>
            </div>
          </div>
          <div
            class="w-full md:w-[calc(100%-340px)] lg:w-[calc(100%-420px)] xl:pe-10"
          >
            <h4 class="head_h4">
              {{ headline.value }}
            </h4>
            <div>
              {{ text.value }}
              <NuxtLink :to="'/shop-service/kontakt/'" class="underline">
                {{ $t("form.contact-form") }}
              </NuxtLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
